import api from './api';

export interface BlogPost {
  _id: string;
  title: string;
  slug: string;
  summary: string;
  content: string;
  author: {
    _id: string;
    name: string;
    email: string;
    avatar?: string;
  };
  publishedAt?: string;
  category: string;
  image: string;
  tags: string[];
  status: 'draft' | 'published';
  views: number;
  createdAt: string;
  updatedAt: string;
}

export const blogApiService = {
  async getAllPosts(params?: {
    status?: string;
    category?: string;
    tag?: string;
    search?: string;
    page?: number;
    limit?: number;
  }): Promise<{
    posts: BlogPost[];
    pagination: { page: number; limit: number; total: number; pages: number };
  }> {
    const queryParams = new URLSearchParams(params as any);
    const response = await api.get(`/blog/posts?${queryParams}`);
    return response.data.data;
  },

  async getPostBySlug(slug: string): Promise<BlogPost> {
    const response = await api.get<{ success: boolean; data: BlogPost }>(`/blog/posts/${slug}`);
    return response.data.data;
  },

  async createPost(data: {
    title: string;
    slug: string;
    summary: string;
    content: string;
    category: string;
    image: string;
    tags?: string[];
    status?: 'draft' | 'published';
  }): Promise<BlogPost> {
    const response = await api.post<{ success: boolean; data: BlogPost }>('/blog/posts', data);
    return response.data.data;
  },

  async updatePost(id: string, data: Partial<{
    title: string;
    slug: string;
    summary: string;
    content: string;
    category: string;
    image: string;
    tags: string[];
    status: 'draft' | 'published';
  }>): Promise<BlogPost> {
    const response = await api.put<{ success: boolean; data: BlogPost }>(`/blog/posts/${id}`, data);
    return response.data.data;
  },

  async deletePost(id: string): Promise<void> {
    await api.delete(`/blog/posts/${id}`);
  },

  async publishPost(id: string): Promise<BlogPost> {
    const response = await api.patch<{ success: boolean; data: BlogPost }>(`/blog/posts/${id}/publish`);
    return response.data.data;
  },

  async getCategories(): Promise<string[]> {
    const response = await api.get<{ success: boolean; data: string[] }>('/blog/categories');
    return response.data.data;
  },

  async getTags(): Promise<string[]> {
    const response = await api.get<{ success: boolean; data: string[] }>('/blog/tags');
    return response.data.data;
  }
};
